var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12869",
    "data-name": "Group 12869",
    transform: "translate(-653 -2475)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_36",
    "data-name": "Ellipse 36",
    cx: 32,
    cy: 32,
    r: 32,
    transform: "translate(653 2475)",
    fill: "#f4ea5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2108",
    "data-name": "Path 2108",
    d: "M35.945,29.148l-4.064-2.709-3.613-2.408a1.6,1.6,0,0,0-2.149.349l-2.235,2.874a1.592,1.592,0,0,1-2.033.422c-1.517-.844-3.311-1.638-7.268-5.6s-4.757-5.751-5.6-7.268A1.592,1.592,0,0,1,9.4,12.774l2.874-2.235a1.6,1.6,0,0,0,.349-2.149l-2.334-3.5L7.509.713A1.6,1.6,0,0,0,5.355.228L2.145,2.154a3.922,3.922,0,0,0-1.781,2.3c-.878,3.2-1.055,10.261,10.26,21.576S29,37.172,32.2,36.294a3.921,3.921,0,0,0,2.3-1.781L36.43,31.3A1.6,1.6,0,0,0,35.945,29.148Z",
    transform: "translate(666.671 2488.671)",
    fill: "#143727"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.5928b47da53bd5251930fee5a75b4c5c.svg";
export { ForwardRef as ReactComponent };